import { FIRESTORE_BASE_URL } from '../constants/config'

export const firestoreGet = async endpoint => {
	const url = `${FIRESTORE_BASE_URL}/${endpoint}`

	const response = await fetch(url, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	})

	if (!response.ok) {
		throw new Error(`Failed to fetch ${endpoint}: ${response.status}`)
	}

	return response.json()
}
